'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * The base chart config to use for sparkline type charts.
 */
ngModule.factory('sparklineChartOptions', function () {
  return {
    chart: {
      type: 'line',
      height: '50',
      width: '150',
      zoomType: null,
      margin: [0, 0, 0, 0],
      backgroundColor: "#fafaff"
    },
    legend: {
      enabled: false
    },
    xAxis: {
      labels: {
        enabled: false
      },
      alternateGridColor: null,
      startOnTick: false,
      endOnTick: false
    },
    yAxis: {
      labels: {
        enabled: false
      }
    },
    tooltip: {
      enabled: false,
      crosshairs: false
    },
    exporting: {
      enabled: false
    },
    plotOptions: {
      series: {
        animation: false
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/highchart-sparkline-options.js
// module id = 2961
// module chunks = 13